import operations from '../operations';
import { LOCATIONS_DIALOG, LocationsDialog, } from '../../settings/tabs/clinic-settings';
import { CONFIRM_DIALOG } from '../constants/dialog-types';
import { ConfirmDialog } from '../components/confirm-dialog';
export const registerDialogs = () => {
    operations.register(LOCATIONS_DIALOG, LocationsDialog);
    operations.register(CONFIRM_DIALOG, ConfirmDialog);
};
export const unregisterDialogs = () => {
    operations.unregister(LOCATIONS_DIALOG);
    operations.unregister(CONFIRM_DIALOG);
};
